import request from '@/utils/request-axios'
import blobRequest from '@/utils/blobRequest'
import fileRequest from '@/utils/fileRequest'
import api from '@/utils/api'

//省市区
export function getCity() {
  return request(`${api.getCity}`, {
    loading: true,
    method: 'get',
  });
}

//角色list
export function getRoleList() {
  return request(`${api.getRoleList}`, {
    loading: true,
    method: 'get',
  });
}

//公司list
export function getCompanyList(params) {
  return request(`${api.getCompanyList}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//用户list
export function getUserList(params) {
  return request(`${api.getUserList}`, {
    loading: true,
    method: 'get',
    data: params
  });
}


export function uploadFile(params) {
  return fileRequest(`${api.uploadFile}`, {
    loading: true,
    headers: {'content-type': 'multipart/form-data'},
    method: 'post',
    data: params
  });
}




// WEBPACK FOOTER //
// ./src/services/common.js